import { render } from "./TestResultProductForPrescription.vue?vue&type=template&id=f823ac9e&scoped=true"
import script from "./TestResultProductForPrescription.vue?vue&type=script&lang=js"
export * from "./TestResultProductForPrescription.vue?vue&type=script&lang=js"

import "./TestResultProductForPrescription.vue?vue&type=style&index=0&id=f823ac9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f823ac9e"]])

export default __exports__